const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/sections/fields/UnfallVersicherungField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const UnfallVersicherungField = generateMetaKatDropDownField(
    '0397aebd-7669-42e2-940a-41e06d6ec0f1',
    'UnfallVersicherungField'
);

export default UnfallVersicherungField;
